<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Aggregate Settlement Details" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-10">
                <p class="mt-1">
                  <span class="text-dark font-weight-bolder font-small-3">Settlement ID: <span
                      class="text-primary badge badge-light-primary font-small-2">{{ mainSettlement.uuid }}</span> </span>
                  <span class="text-dark font-weight-bolder font-small-3 ml-sm-1">From Date: <span
                      class="text-primary badge badge-light-success font-small-2">{{ mainSettlement.from_date }}</span></span>
                  <span class="text-dark font-weight-bolder font-small-3 ml-sm-1">To Date: <span
                      class="text-primary badge badge-light-success font-small-2">{{
                      mainSettlement.to_date
                    }}</span></span>
                  <span class="text-dark font-weight-bolder font-small-3 ml-sm-1">Account: <span
                      class="badge badge-primary badge-glow font-small-2">{{ currencyCode }}</span></span>
                </p>
              </div>
              <div class="col-2 mt-1">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-gradient-danger btn-sm"
                      @click="backTo"
                  >
                    <span class="text-nowrap">Back To Settlement</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              url="v1/settlements"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :filteredData="filteredData"
              :loadMore="true"
              :hidePerPage="true"
              :forceShowActionHeader="true"
              :tableAccordian="refunded_transactionTable"
              :showOnlyAccordian="true"
              :accordianCondition="accordianCondition"
              :exportData="exportData"
              :hidePdfExportButton="true"
          />
        </div>
        <section id="basic-horizontal-layouts">
          <div class="row ">
            <div class="col-md-12 col-12 ">
              <div class="card border-primary badge-glow">
                <div class="card-header">
                  <h4 class="card-title">Settlement Details</h4>
                </div>
                <div class="card-body">
                  <div class="row ">
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Payable Amount</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">{{ parseFloat(mainSettlement.amount / 100).toFixed(amountDecimalPlaces
                            ) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Fee</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">
                              {{ parseFloat(mainSettlement.fee / 100).toFixed(feesDecimalPlaces) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Vat</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">
                              {{ (parseFloat(mainSettlement.vat / 100).toFixed(feesDecimalPlaces)) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Settlement Amount</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">
                              {{
                                ((settlementBeforeReserve = (parseFloat(parseFloat(mainSettlement.amount) - parseFloat(mainSettlement.vat) - parseFloat(mainSettlement.fee)) / 100)).toFixed(amountDecimalPlaces))
                              }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-if="merchantSettlementRollingReserve">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Reserve (%)</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-danger font-weight-bolder">
                              {{ merchantSettlementRollingReserve.rolling_reserve +'%'}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-if="merchantSettlementRollingReserve">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Reserve (Amount):</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-danger font-weight-bolder">
                              {{reserve = ((parseFloat(merchantSettlementRollingReserve.amount))/100)}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-if="merchantSettlementRollingReserve">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Settlement After Reserve :</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-danger font-weight-bolder">
                              {{ parseFloat(parseFloat(settlementBeforeReserve) -  parseFloat(reserve)).toFixed(amountDecimalPlaces) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {
  props: ['propFilters'],
  mounted() {
    this.mainSettlement = this.$store.getters.getSettlementData
    this.currencyCode = this.mainSettlement.user_account.currency.code
    this.merchantSettlementRollingReserve = this.mainSettlement?.rolling_reserve
  },
  data() {
    return {
      merchantSettlementRollingReserve:null,
      reserve:0,
      settlementBeforeReserve:0,
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'settlement',
            // perPage: 10,
            settlementId: this.$route.params.id
          }


          this.downloadReport(requestData)
        }
      },
      currencyCode: '',
      mainSettlement: '',
      breadcrumb: [
        {name: 'App'},
        {name: 'Settlement'},
        {name: 'Aggregate'},
        {name: 'Detail'},
      ],
      filteredData: {settlementId: this.$route.params.id},
      refunded_transactionTable: [
        {
          header: [
            {
              title: 'UUID'
            },
            {
              title: 'Amount'
            },
            {
              title: 'Fee'
            },
            {
              title: 'Vat'
            },
            {
              title: 'Time/Date'
            },
          ],
          body: {
            getData: (row) => {
              let finalData = []
              if (row.refunded_transaction) {
                let temp = []
                temp.push(row.refunded_transaction.uuid)
                temp.push(row.refunded_transaction.amount / 100)
                temp.push(row.refunded_transaction.fee / 100)
                temp.push(row.refunded_transaction.vat / 100)
                temp.push(this.customFormatDateTime(row.refunded_transaction.created_at))

                finalData.push(temp)
              }
              return finalData
            }
          },
        }
      ],
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span>`


            return html


          },
          cta: (row) => {
            this.$router.push({name: 'transactions-details-with-id',params: {id:row.uuid}})
          }
        },
        {
          title: 'Sender Account Title',
          valueKey: 'sender_account_title',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-light-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Sender Account Num',
          valueKey: 'sender_account_number',
        },
        {
          title: 'Receiver Account Title',
          valueKey: 'receiver_account_title',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-light-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Actual Amount',
          valueKey: 'amount',
          html: true,
          alter: (value) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed( this.amountDecimalPlaces)}</span>`


            return html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          alter: (value) => {
            return parseFloat(value / 100).toFixed(this.feesDecimalPlaces)
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</span>`


            return html


          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          customClass: 'text-center',
          html: true,
          alter: (value, row) => {
            var html = ''
            if (value) {
              if (row.transaction_type_id == 6) {
                html = `<span style="font-size: larger" class=" font-weight-bolder text-danger row justify-content-center">- ${parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces)}</span>
                <div class="badge badge-light-success mt-1">Refunded</div>`
              }
              else if (row.transaction_type_id == 11 &&  row.sender_user_id == this.$store.getters.getLoggedInUser.id) {
                html = `<span style="font-size: larger" class=" font-weight-bolder text-danger row justify-content-center">- ${parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces)}</span>
                <div class="badge badge-light-primary mt-1">Adjusted</div>`
              }
              else {

                html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat((value - row.vat - row.fee) / 100).toFixed(this.amountDecimalPlaces)}</span>`

              }
            }


            return html


          }
        },
        {
          title: 'Reference Id',
          valueKey: 'reference_id',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          }
        },
        {
          title: 'Time/Date',
          valueKey: 'created_at',
       alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [],
      accordianCondition:
          {
            condition: (row) => {
              if (row.transaction_type_id == 6) {
                return true
              }
              return false
            },
          },
    }
  },
  methods: {
    backTo(){
      let propFilters = this.propFilters
      this.$router.push({name:'settlements',query: { tab: 1 },params:{propFilters}})

    },
  }
}
</script>

